import abText from "../logos/ABText.svg";

export const ABText = () => {
  return <img alt="ABLogo" src={abText} />;
};
